export const custStatusDataSource = [
  { value: "All", text: "All Status" },
  { value: "A", text: "Active" },
  { value: "I", text: "Inactive" },
];

export const custStatusDataSource2 = [
  { text: "Active", value: "active" },
  { text: "Inactive", value: "inactive" }
];
export const custStatusDataSource3 = [
  { text: "Active", value: "A" },
  { text: "Inactive", value: "I" }
];

export const custPwdDataSource = [
  { value: "All", text: "All Password Status" },
  { value: "Pending", text: "Pending" },
  { value: "Changed", text: "Changed" },
];

export const typeOptions = [
  { value: "web_application", text:  "Web Application" },
  { value: "sap", text:  "SAP" }
];
 
export const yesnoDataSource = [
  {
    value: "Yes",
    text: "Yes",
  },
  {
    value: "No",
    text: "No",
  },
];